<template>
  <v-snackbar
    :value="!!csvUploadStatus"
    top
    color="white"
    :timeout="0"
    class="pa-0"
  >
    <v-flex
      pl-2
      d-flex
      class="snackBar-container"
      :style="{cursor: complete ? 'pointer' : 'default'}"
      @click="updateHandler(false)"
    >
      <v-progress-circular
        :rotate="-90"
        :size="40"
        :width="3"
        :value="csvUploadStatus"
        :color="progressColor"
      >
        {{ csvUploadStatus }}
      </v-progress-circular>

      <div
        style="width: 300px;"
        class="my-0 mx-3"
      >
        <div
          :class="{
            'text-xs-center': !complete,
            'red--text font-weight-bold': failed
          }"
        >
          {{ statusText }}
        </div>
        <div v-show="complete">
          クリックすると新しいデータを取得します。
        </div>
      </div>
      <div
        :style="{visibility: (complete || failed) ? 'visible' : 'hidden'}"
        class="close-btn"
        @click.stop="updateHandler(true)"
      >
        <v-icon
          class="close-icon"
          medium
        >
          mdi-close
        </v-icon>
      </div>
    </v-flex>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ProgressBar',
  data () {
    return {
      complete: false
    }
  },
  computed: {
    ...mapState('customers', ['csvUploadStatus']),
    failed () {
      return this.csvUploadStatus === -1
    },
    statusText () {
      if (this.complete) {
        return 'CSVの登録処理が完了しました。'
      }
      return this.failed
        ? 'CSVの登録処理に失敗しました。'
        : 'CSVの登録処理中です...'
    },
    progressColor () {
      if (this.complete) {
        return 'success'
      }
      return this.failed
        ? 'red'
        : 'warning'
    }
  },
  watch: {
    csvUploadStatus (v) {
      this.complete = false
      if (v === 100) {
        setTimeout(() => {
          this.complete = true
        }, 800)
      }
    }
  },
  methods: {
    updateHandler (close) {
      if (!this.complete && !this.failed) return

      this.$store.commit('customers/setCsvUploadStatus', 0)
      if (close) return

      this.$store.dispatch('dashboard/initDashboardData')
      this.$store.dispatch('list/setCustomers')
      this.$store.dispatch('customers/search')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.v-progress-circular__info{
  font-size: 0.9rem;
  font-weight: bold;
}
/deep/.v-snack__content{
  padding: 0 !important;
  border-radius: 5px;
}
.close-btn{
  background: white;
  padding: 26px 15px;
  border-left: 1.5px solid rgba(128, 128, 128, 0.322);
  border-radius: 0 3px 3px 0;
  cursor: pointer;
  &:hover{
    background: red;
    .close-icon{
      color: white!important;
    }
  }
}
.close-icon{
  color: red!important;
  font-size: 1.3rem!important;
}
.snackBar-container{
  align-items: center;
  color: black;
}
</style>
